import { Injectable } from '@angular/core'
import * as forge from 'node-forge'

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() {}

  encrypt(data: string): string {
    if (!data) {
      return null
    }
    // tslint:disable-next-line: max-line-length
    const pubkPem =
      '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrcpBnA1aSTOQkvjKsSIuuxQH/mZhCn6CSmWbePocUpa50uD3+XzaMisIew4oKfq50zsU0DpAMbk6CABwU0QGBxdpZfhWdIs/5nCyIn5n5Z6K4oLRNMZap0RXD9XHe2RIJ915Xc5/bH2KbSiMoW9FpTCYAatdarxfkpGCr4tmH9QIDAQAB-----END PUBLIC KEY-----'
    const pubk = forge.pki.publicKeyFromPem(pubkPem)

    // Encrypt the plain text using the public key
    const encryptedData = pubk.encrypt(data)
    // Encode the encrypted data in base64
    const encodedData = forge.util.encode64(encryptedData)
    return encodedData
  }
}
